/** Временно отключить биллинг/подписку в UI и запросы при старте. */
export const ENABLE_BILLING = false;
